export const content = {
  frequentQuestions: "Frequent Questions",
  appPromo: {
    heading: "Get help fast with the Origin App",
    headingPrefix: "Get help fast with the",
    headingHighlight: "Origin App",
    description:
      "You can request for payment extensions, manage your account and use our chat feature on the go without the wait!",
    cta: "Download our award-winning app",
    qrCodeAlt: "QR code for the Origin app",
    heroImageMobileAlt: "",
    heroImageDesktopAlt: "",
  },
};
